import { useTheme } from "@mui/material"
import { ReactSVG } from "react-svg"

interface SvgIconPropsInterface {
  src: string
  size?: string
  fill?: string
  style?: any
  height?: string | number
  width?: string | number
}
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SvgIcon = ({ src, size = "1rem", width, fill = "transparent", height, style = {} }: SvgIconPropsInterface) => {
  const theme = useTheme()
  return (
    <ReactSVG
      aria-label="threeshelvesicons"
      beforeInjection={(svg: any) => {
        svg.setAttribute("width", width ? width : size)
        svg.setAttribute("height", height ? height : size)
        svg.setAttribute("color", "currentcolor")
        svg.setAttribute("fill", fill)
      }}
      style={{ color: theme?.palette?.primary?.main, ...style }}
      role="icon"
      src={src}
    />
  )
}

export default SvgIcon
